/* eslint-disable */
import * as types from '../actions/types';

const initialState = {
  methodical: [],
  content: [],
};

export default function metoRoom(state = initialState, action) {
  switch (action.type) {
    case types.METHODICAL_FETCH_COMPLETED: {
      let methodical = action.methodical;
      methodical.forEach((elem) => {
        elem.children = [];
        if (elem.haschild !== 0) {
          elem.children = methodical.filter(e => e.mr_parent === elem.mrid);
          methodical = methodical.filter(e => e.mr_parent !== elem.mrid);
        }
      });
      return {
        ...state,
        methodical,
        content: [],
      };
    }
    case types.METHODICAL_CONTENT_FETCH_COMPLETED:
      return {
        ...state,
        content: action.content,
      };
    default:
      return state;
  }
}
